export const DROPDOWNS_ACTION_TYPES = {
  SET_CART_DROPDOWN: 'dropdowns/SET_CART_DROPDOWN',
  SET_LOGIN_DROPDOWN: 'dropdowns/SET_LOGIN_DROPDOWN',
};